import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import type {
  ITransferPricingPolicyDocumentVersion,
  ITransferPricingPolicyDocumentVersionsResponse,
} from './types';

const NO_DOCUMENT_VERSIONS: ITransferPricingPolicyDocumentVersion[] = [];

/** Pass null to disable the request entirely, the way the policy page does until the policy is found. */
export const usePolicyDocumentVersions = (policyId: string | null) => {
  const { data, error, isLoading, mutate } =
    useSWR<ITransferPricingPolicyDocumentVersionsResponse>(
      policyId ? `transfer-pricing/policy/${policyId}/document-version` : null,
      SWRFetcher({ method: 'GET' })
    );

  return {
    documentVersions: data?.documentVersions ?? NO_DOCUMENT_VERSIONS,
    count: data?.count ?? 0,
    isLoading,
    error,
    mutate,
  };
};
